import { motion } from "framer-motion";

// Staggered fade-up reveal used across sections.
export function Reveal({ children, delay = 0, y = 24, className = "", as = "div" }) {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </MotionTag>
    );
}

// Kinetic line-by-line masked reveal (for hero headings).
export function MaskLine({ children, delay = 0, className = "" }) {
    return (
        <span className="block overflow-hidden">
            <motion.span
                className={`block ${className}`}
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
            >
                {children}
            </motion.span>
        </span>
    );
}

// The 4-square red window-grid motif from the logo.
export function WindowGrid({ className = "", size = 20 }) {
    const cell = "bg-brand-red rounded-[2px]";
    return (
        <span
            className={`inline-grid grid-cols-2 gap-[2px] ${className}`}
            style={{ width: size, height: size }}
            aria-hidden="true"
        >
            <span className={cell} />
            <span className={cell} />
            <span className={cell} />
            <span className={cell} />
        </span>
    );
}
